import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import PriceRange from '../../components/PriceRange.jsx';

function findSibling(element) {
    return Array.prototype.filter.call(
        element.parentNode.children,
        function (child) {
            return child !== element;
        }
    );
}

const _isExtraSmallScreen = Modernizr.mq('(max-width: 48em)');
const priceRange = document.getElementsByClassName('price-range');

if (priceRange !== null && priceRange !== undefined) {
    if (priceRange.length > 0) {
        for (let index = 0; index < priceRange.length; index++) {
            const element = priceRange[index];
            ReactDOM.render(<PriceRange {...element.dataset} />, element);
        }
    }
}

const skipMenu = document.querySelector('.skip-menu');
if (skipMenu !== null && skipMenu !== undefined) {
    skipMenu.parentElement
        .querySelector('.sub-navigation')
        .classList.add(_isExtraSmallScreen ? 'is-close' : 'is-open');

    skipMenu.onclick = (e) => {
        e.preventDefault();
        Array.prototype.forEach.call(
            findSibling(e.currentTarget),
            (sibling) => {
                sibling.classList.toggle('is-close');
            }
        );
        e.currentTarget.classList.toggle('is-active');
    };
}

const colorsFilter = document.getElementById('colors_filter');
if (colorsFilter !== null && colorsFilter !== undefined) {
    Array.prototype.forEach.call(
        colorsFilter.querySelectorAll('.sub-navigation__link'),
        (color) => {
            color.style.backgroundColor = color.dataset.color;
        }
    );

    const jsTooltips = document.querySelectorAll('.js-tooltip');
    if (!(window.innerWidth <= 768) && jsTooltips.length > 0) {
        Array.prototype.forEach.call(jsTooltips, (jsTooltip) => {
            jsTooltip.onmouseenter = (e) => {
                let title = e.currentTarget.getAttribute('title');
                e.currentTarget.setAttribute('data-tipText', title);
                // e.currentTarget.removeAttribute('title');
                const toolTipSpan = document.createElement('span');
                toolTipSpan.setAttribute('class', 'tooltip');
                toolTipSpan.innerHTML = title;
                document.querySelector('body').appendChild(toolTipSpan);
                toolTipSpan.style.display = 'block';
            };
            jsTooltip.onmouseleave = (e) => {
                document.querySelector('.tooltip').remove();
            };
            jsTooltip.onmousemove = (e) => {
                let mousex = e.pageX + 12;
                let mousey = e.pageY - 36;
                document.querySelector('.tooltip').style.left = mousex + 'px';
                document.querySelector('.tooltip').style.top = mousey + 'px';
            };
        });
    }
}
